//

import { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Resizeble extends PureComponent {
    static propTypes = {
        children: PropTypes.node,
        updateHeight: PropTypes.func,
    };

    static defaultProps = {
        onResize: () => {},
    };

    componentDidUpdate() {
        this.props.onResize();
    }

    componentDidMount() {
        window.addEventListener('resize', this.props.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.props.onResize);
    }

    render() {
        const { children } = this.props;
        return children;
    }
}

export default Resizeble;
